import { useMemo, useState } from 'react';
import { UsersFilter } from '../models';

const createInitialFilter = (): UsersFilter => ({
  fullName: '',
  email: '',
  phone: '',
  status: undefined,
});

const getStoredFilter = (initialFilter: UsersFilter): UsersFilter => {
  const raw = localStorage.getItem('usersFilters');
  if (!raw) return initialFilter;

  try {
    const stored = JSON.parse(raw);
    return {
      ...initialFilter,
      ...stored,
    };
  } catch {
    return initialFilter;
  }
};

const useUsersFilter = () => {
  const initialFilter: UsersFilter = useMemo(createInitialFilter, []);

  const [filter, setFilter] = useState<UsersFilter>(() =>
    getStoredFilter(initialFilter)
  );

  return {
    initialFilter,
    filter,
    setFilter,
  };
};

export default useUsersFilter;
